import { Waves, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/i18n/LanguageContext";

export const ErrorState = ({ message, onRetry, testId }) => {
  const { t } = useLanguage();
  return (
    <div className="pt-16 flex flex-col items-center text-center gap-4">
      <Waves className="text-cyan-300/60" size={32} />
      <p className="text-sm text-[hsl(var(--muted-foreground))]">{message}</p>
      <Button
        data-testid={testId}
        onClick={onRetry}
        variant="outline"
        className="rounded-xl bg-white/5 border-white/10 hover:bg-white/10"
      >
        <RefreshCw size={16} className="mr-2" /> {t("common.tryAgain")}
      </Button>
    </div>
  );
};
